import React, { ReactNode, MouseEventHandler, forwardRef } from 'react';
import { Link } from '@/i18n/navigation';

type AppLinkProps = {
  children: ReactNode;
  href?: string;
  title?: string;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  target?: '_blank' | '_self' | '_parent' | '_top';
  prefetch?: boolean;
  style?: React.CSSProperties;
  onMouseMove?: MouseEventHandler<HTMLAnchorElement>;
  onMouseLeave?: MouseEventHandler<HTMLAnchorElement>;
  onMouseEnter?: MouseEventHandler<HTMLAnchorElement>;
};

const AppLink = forwardRef<HTMLAnchorElement, AppLinkProps>(
  (
    {
      children,
      href = '',
      title,
      className = '',
      onClick,
      target = '_parent',
      prefetch = false,
      style = {},
      onMouseMove,
      onMouseLeave,
      onMouseEnter,
    },
    ref,
  ) => {
    return (
      <Link
        ref={ref}
        prefetch={prefetch}
        href={href}
        className={className}
        target={target}
        title={title}
        onClick={onClick}
        aria-label={title}
        style={style}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        onMouseEnter={onMouseEnter}
      >
        {children}
      </Link>
    );
  },
);

AppLink.displayName = 'AppLink';

export default AppLink;
